/**
 * Created by chenrozenes on 14/12/2016.
 */

export const NONE = 0; // Exists only in client
export const READ = 1;
export const WRITE = 10;
export const ADMIN = 50;
export const SUPER_ADMIN = 99;
